module.exports = __webpack_public_path__ + "static/media/Guide.7b1f2713.png";